import { SnackbarProvider, useSnackbar } from '@eduact/ed-components'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { SnackbarConfig } from '@Utilities/SnackbarConfig'
import React, { useEffect } from 'react'

const EdSnackbarProvider: React.FC = ({ children }) => {
	const { opened, text, status } = useAppSelector(state => state.snackbar)

	const { openSnackbar } = useSnackbar()
	useEffect(() => {
		if (status) {
			// FSI/PDI isolate the message: backend messages can be English inside the
			// RTL page, which otherwise bidi-shifts trailing punctuation to the front
			const FSI = String.fromCharCode(0x2068)
			const PDI = String.fromCharCode(0x2069)
			openSnackbar({ ...SnackbarConfig[status], text: text ? FSI + text + PDI : text })
		}
	}, [text, status])
	return <>{children}</>
}

export default EdSnackbarProvider
